/* global SENTRY_PUBLIC_DSN */
import * as Sentry from '@sentry/browser';


if (SENTRY_PUBLIC_DSN && SENTRY_PUBLIC_DSN !== '') {
  Sentry.init({
    dsn: SENTRY_PUBLIC_DSN,
    environment: process.env.NODE_ENV,
  })
}


